import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactList } from '@core/models//contact-list.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from './../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ContactListHttpService {

  constructor(private http: HttpClient) { }

  getContactList(): Observable<ContactList[]> {
    return this.http.get<ApiResponse>(`/contact`).pipe(
      map(res => res.data)
    );
  }

  getContactListByPlatform(platform: string, contact_type: string) {
    return this.http.get<ApiResponse>(`/contact?platform=${platform}&contact_type=${contact_type}`).pipe(
      map(res => res.data)
    );
  }

}
